import React from 'react';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCalendar, FiClock, FiMapPin, FiChevronRight } = FiIcons;

const STATUS_CONFIG = {
  assigned: { label: 'Assigned', color: 'bg-gray-100 text-gray-700', border: 'border-l-gray-400' },
  driver_accepted: { label: 'Accepted', color: 'bg-blue-100 text-blue-700', border: 'border-l-blue-500' },
  driver_on_the_way: { label: 'On The Way', color: 'bg-orange-100 text-orange-700', border: 'border-l-orange-500' },
  driver_reached_pickup: { label: 'Reached', color: 'bg-purple-100 text-purple-700', border: 'border-l-purple-500' },
  pickup_started: { label: 'Collecting', color: 'bg-teal-100 text-teal-700', border: 'border-l-teal-500' },
  pickup_completed: { label: 'Completed', color: 'bg-green-100 text-green-700', border: 'border-l-green-500' },
  processing: { label: 'Processing', color: 'bg-indigo-100 text-indigo-700', border: 'border-l-indigo-500' },
  delivered: { label: 'Delivered', color: 'bg-green-100 text-green-700', border: 'border-l-green-500' },
};

export default function JobCard({ job }) {
  const navigate = useNavigate();
  const cfg = STATUS_CONFIG[job.status] || STATUS_CONFIG.assigned;
  const addr = job.pickup_address || {};

  return (
    <div
      onClick={() => navigate(`/driver/job/${job.id}`)}
      className={`bg-white rounded-2xl shadow-sm border border-gray-100 border-l-4 ${cfg.border} p-4 cursor-pointer active:scale-[0.98] transition-transform`}
    >
      <div className="flex justify-between items-start mb-2">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${cfg.color}`}>
              {cfg.label}
            </span>
            <span className="text-xs text-gray-400 font-mono">{job.booking_number}</span>
          </div>
          <h3 className="font-bold text-brand-navy text-base">
            {job.profiles?.full_name || 'Customer'}
          </h3>
        </div>
        <FiChevronRight className="text-gray-400 text-xl shrink-0 mt-1" />
      </div>

      <div className="flex flex-col gap-1 text-sm text-gray-500">
        <span className="flex items-center gap-1.5">
          <FiCalendar className="text-brand-gold shrink-0" />
          {job.pickup_date}
          <FiClock className="text-brand-gold ml-2 shrink-0" />
          {job.pickup_slot?.split(' - ')[0]}
        </span>
        <span className="flex items-center gap-1.5">
          <FiMapPin className="text-brand-gold shrink-0" />
          <span className="truncate">{addr.line1}, {addr.locality}, {addr.city}</span>
        </span>
      </div>

      <div className="mt-3 pt-3 border-t border-gray-50">
        <span className="text-xs font-semibold text-brand-navy bg-brand-light px-3 py-1 rounded-full">
          View Details →
        </span>
      </div>
    </div>
  );
}